import React from 'react';
import './GoogleReviewsButton.css';

export default function GoogleReviewsButton({ onClick }) {
    return (
        <button className="google-reviews-btn" onClick={onClick}>
            Click here for Google Maps Reviews
        </button>
    );
}
